import { DohResolver } from 'dohjs'

export default class DnsService {
  resolver = new DohResolver('https://1.1.1.1/dns-query')

  resolve = url => this.resolver.query(url, 'A')
}
